import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setEditCurrentView } from "store/actions/charts";
import { addTagInWidget, fetchNormalizedTags, updateChartFilters } from "store/thunk/charts";

import { extractLayout } from "utils/utils";
import { ChartStrings } from "constants/constantStrings";
import { TAG_TYPES } from "constants/globalConstants";

import createNotification, { INFO_NOTIFICATION } from "components/Notifications";
import TagDropdown from "components/TagDropdown";

import { CHART_HEADER_ACTIONS, TagColorOptions } from "../../../constants/chartConstant";

import ChartNormalizedTagDialog from "./ChartNormalizedTagDialog";

export default function ChartAddTag(props) {
  const {
    chartLayoutID,
    disabled,
    onChartTagAdditon,
    isNormalizedTagDialogOpen,
    tagValue,
    setTagValue,
    onTagSelection,
    normalizedTagConfig,
    setNormalizedTagConfig
  } = props;

  const dispatch = useDispatch();
  const { Tags, TagOptions, NormalizedTags, IsChartUpdating, NormalizationFilters, TagDefaultConfig, PlotZoomData } = useSelector(
    state => state.chartData
  );
  const LayoutID = extractLayout();

  useEffect(() => dispatch(fetchNormalizedTags()), []);
  useEffect(() => {
    if (!IsChartUpdating) {
      setTagValue(null);
    }
  }, [IsChartUpdating]);

  useEffect(() => {
    if (isNormalizedTagDialogOpen !== "ADD") {
      setNormalizedTagConfig(null);
      dispatch(setEditCurrentView(CHART_HEADER_ACTIONS.NONE));
    }
  }, [isNormalizedTagDialogOpen]);

  const getAvailableColor = () => {
    const usedColors = Tags.map(tag => tag.Color);
    return TagColorOptions.filter(color => !usedColors.includes(color.code));
  };

  const getAddTagPayload = TagId => {
    const availableColors = getAvailableColor();
    const { Type } = TagDefaultConfig;
    const Show = true;
    return { LayoutID, TagId, Color: availableColors[0].code, Type, Show };
  };

  const showZoominStateMsg = () => {
    createNotification(INFO_NOTIFICATION, ChartStrings.zoominAddTagWarning, "");
  };

  const onTagChange = async value => {
    onTagSelection();
    if (value) {
      setTagValue(value);
      if (PlotZoomData?.xRange) {
        showZoominStateMsg();
      }
      addNewTag(value);
    } else {
      onCloseNormalizedForm();
    }
  };

  const addNewTag = async value => {
    const isNormalized = value.Type === TAG_TYPES.NORMALIZED;
    if (isNormalized && !NormalizedTags.length) {
      const tagsConfig = [{ id: "Tag1", value, required: true }];
      setNormalizedTagConfig(tagsConfig);
      dispatch(setEditCurrentView(CHART_HEADER_ACTIONS.ADD_NORMALIZE_TAG));
    } else {
      const { TagId } = value;
      const baselineId = isNormalized && NormalizationFilters.Baseline;
      const payload = getAddTagPayload(TagId);
      dispatch(addTagInWidget(payload, baselineId));
      setTimeout(() => onCloseNormalizedForm());
    }
  };

  const onCloseNormalizedForm = (filtersPayload, tagId) => {
    setTagValue(null);
    setNormalizedTagConfig(null);
    dispatch(setEditCurrentView(CHART_HEADER_ACTIONS.NONE));
    if (filtersPayload) {
      let tagPayload = null;
      if (tagId) {
        tagPayload = getAddTagPayload(tagId);
      }
      dispatch(updateChartFilters(filtersPayload, tagPayload));
    }
  };

  return (
    <div>
      <TagDropdown
        tagValue={tagValue}
        dropDownID="ChartTagDropDown"
        tagList={TagOptions}
        onTagChange={onTagChange}
        isLoaded
        showLoading={false}
        disabled={disabled}
      />
      {normalizedTagConfig && (
        <ChartNormalizedTagDialog
          setCreateBaseline={props.setCreateBaseline}
          tagsConfig={normalizedTagConfig}
          LayoutID={chartLayoutID}
          onChartTagAdditon={onChartTagAdditon}
          handleClose={onCloseNormalizedForm}
        />
      )}
    </div>
  );
}
